import { TApplicationReportsForm } from '~/components/ApplicationReports/types.ts';

export const initialValuesApplicationReports: TApplicationReportsForm = {
  fromDate: '',
  toDate: '',
  status: null,
  clientType: null,
  applicationType: null,
  lastUpdatedTo: null,
  toboId: null,
  initiatorType: null,
  page: 0,
  size: 50,
};
